import type { FrameColor, Product } from "@/models/product";

/**
 * Finds the first frame colour whose `hexColor` matches the supplied
 * `outerHex` case-insensitively. Used to default the sun-protection
 * frame colour to the kozijn's `outerColor` so the configured product
 * lines up with the installed window.
 *
 * Returns `null` when the product has no frame colour, when no hex was
 * supplied, or when no frame colour matches.
 */
export function findFrameByOuterHex(
    product: Product,
    outerHex: string | undefined,
): FrameColor | null {
    if (!product.hasFrameColor || !outerHex) return null;
    const target = outerHex.toLowerCase();
    return (
        product.frameColors.find((c) => c.hexColor?.toLowerCase() === target) ??
        null
    );
}
